import { c as _c } from "react/compiler-runtime";
import { SortSelector } from "@components/common/sort-selector";
import { PROJECTS_SORT_BY_MAP, PROJECTS_SORT_OPTIONS } from "@components/projects/projects-sort-constants";
import { getProjectsSortBy } from "@components/projects/projects-sort-utils";
/** Component to change the projects sort criteria */
export function ProjectsSort(t0) {
  const $ = _c(5);
  const {
    sortBy,
    setSortBy
  } = t0;
  const t1 = PROJECTS_SORT_BY_MAP[sortBy];
  let t2;
  if ($[0] !== setSortBy) {
    t2 = newSortItem => {
      const newSortBy = getProjectsSortBy(newSortItem);
      setSortBy(newSortBy);
    };
    $[0] = setSortBy;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <SortSelector sortOptions={PROJECTS_SORT_OPTIONS} sortItem={t1} setSortItem={t2} subjectType="Project" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}